/**
 * Quali gruppi di campi prodotto sono visibili per l'organizzazione.
 *
 * La configurazione vive in `settings.product_field_visibility` — l'array
 * gestito da Impostazioni → Campi prodotto (`ProductFieldSettings.tsx`) — e vale
 * sia per la scheda in modifica sia per quella in sola lettura. Sta qui, e non
 * dentro una delle due pagine, perche' un gruppo spento deve sparire da
 * entrambe: due copie della stessa regola prima o poi divergono, e il sintomo
 * sarebbe una vista che mostra campi che in modifica non esistono.
 *
 * Un id assente dall'elenco e' considerato VISIBILE: le impostazioni elencano
 * solo i campi governabili, e i gruppi aggiunti dopo (brand,
 * labeling, document_description, waste_forecast) non vi compaiono. Il default
 * permissivo evita che un campo nuovo risulti invisibile finche' qualcuno non
 * apre le impostazioni.
 */

interface ProductFieldVisibilityEntry {
  id: string;
  visible?: boolean;
}

export function isProductFieldVisible(
  settings: { product_field_visibility?: unknown } | null | undefined,
  fieldId: string,
): boolean {
  const fields = settings?.product_field_visibility as ProductFieldVisibilityEntry[] | undefined;
  if (!fields || fields.length === 0) return true;
  const found = fields.find((f) => f?.id === fieldId);
  return found?.visible ?? true;
}

/**
 * Variante opt-in: VISIBILE solo se l'organizzazione ha acceso il gruppo
 * nelle impostazioni. Serve ai gruppi pensati per un singolo cliente (le
 * distinte tipizzate di Ideariso), che con il default permissivo qui sopra
 * comparirebbero a tutte le org che non hanno mai aperto Campi prodotto.
 */
export function isProductFieldOptedIn(
  settings: { product_field_visibility?: unknown } | null | undefined,
  fieldId: string,
): boolean {
  const fields = settings?.product_field_visibility as ProductFieldVisibilityEntry[] | undefined;
  return fields?.find((f) => f?.id === fieldId)?.visible === true;
}
